import { useTranslation } from 'react-i18next';
import { getCurrentRotation } from "../utils/getRotations";

const Rotations = () => {
    const { t } = useTranslation();
    const { people, from, to } = getCurrentRotation();

    return (
        <div className='mb-4'>
            <p className="text-primary-50 text-xs font-mono mb-1">{t('main.rotations_title')}</p>
            <div className=" bg-primary-800 rounded-2xl p-4">
                <div className='flex justify-between'>
                    <h2 className="text-primary-10 text-sm font-mono mb-2">{t('main.rotations_subtitle')}</h2>
                    <p className="text-primary-10 text-xs font-mono ">{from} - {to}</p>
                </div>
                <p className="text-white font-medium">{people}</p>
            </div>
        </div>
    )
}

export default Rotations;